import store from "@/store";

export default {
    notifyUserOfLMRADataSendStatus(message){
        store.commit('setSendingLMRADataState', false);
        store.commit('launchSnackbarMessage', message);
    },
    showSendingDataLoader(){
        store.commit('setSendingLMRADataState' , true);
    }
}